// Every card on /ai comes from this list.
//
// To add one, copy an entry and change the fields. Order here doesn't matter —
// the page sorts by `date` descending.
//
//   id           unique string, used as the React key
//   kind         "Prompt" | "Skill" | "Agent" (shown as the amber label)
//   title        short name for the card
//   date         "YYYY-MM-DD" — the date you published it
//   description  one or two sentences on what it's for
//   tags         optional list, rendered as a quiet middot-separated line
//   content      the artifact itself; this is what the Copy button copies
//
// Use a template literal for `content` so line breaks survive, and escape any
// backticks inside it.

const resources = [
  {
    id: 'plans-as-html',
    kind: 'Prompt',
    title: 'Plans as Previewable HTML',
    date: '2026-07-29',
    description:
      'Enhance your intake by migrating plans to an HTML output with easy to understand visuals.',
    tags: ['planning', 'html', 'diagrams'],
    content: `## Output Rules

* For plans:
  * Give a brief summary.
  * Create previewable HTML.
  * Include diagrams and flow.
  * Show one recommended direction.
  * List user dependencies with exact steps.
  * State when none exist.`,
  },
  {
    id: 'output-rules',
    kind: 'Prompt',
    title: 'Output Rules',
    date: '2026-07-29',
    description:
      'Cuts an assistant down to answers only. Trades grammar and completeness for brevity, on the assumption you will ask a follow-up if you need one.',
    tags: ['brevity', 'output-style', 'system-prompt'],
    content: `## Output Rules

* Be concise. Sacrifice grammar for brevity.
* No walls of text. User will ask for clarification.
* Give one recommendation only. Lead with it.
* Include only actionable information.
* Precision over completeness.`,
  },
];

export default resources;
